/**
 * Generates a URL-safe slug suggestion from a name string.
 * @param {string} name - The input name to slugify
 * @returns {string} A URL-safe slug
 */
export const generateSlugSuggestion = (name) => {
  if (!name) return "";
  return name
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 50);
};
